var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxGrantAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DEEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5607 16.9393C35.1464 17.5251 35.1464 18.4749 34.5607 19.0607L22.5607 31.0607C21.9749 31.6464 21.0251 31.6464 20.4393 31.0607L14.4393 25.0607C13.8536 24.4749 13.8536 23.5251 14.4393 22.9393C15.0251 22.3536 15.9749 22.3536 16.5607 22.9393L21.5 27.8787L32.4393 16.9393C33.0251 16.3536 33.9749 16.3536 34.5607 16.9393Z",
    fill: "#47B35F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGrantAccess);
export default __webpack_public_path__ + "static/media/CheckboxGrantAccess.87554581b55cc0c6c77f44e4e2e0c3ec.svg";
export { ForwardRef as ReactComponent };